import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { photographerTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';

const PhotographyTTK = () => {
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});

    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const formik = useFormik({
        initialValues: {
            canditPrice: Math.floor(merchant?.canditPrice * currency.value) || '',
            cinematicPrice: Math.floor(merchant?.cinematicPrice * currency.value) || '',
            // videographyPrice: merchant?.videographyPrice || '',
            budgetPhotoPrice: Math.floor(merchant?.budgetPhotoPrice * currency.value) || '',
            budgetVideoPrice: Math.floor(merchant?.budgetVideoPrice * currency.value) || '',
            // smallFunctionPhotoPrice: merchant?.smallFunctionPhotoPrice || '',
            studioPhotoPrice: Math.floor(merchant?.studioPhotoPrice * currency.value) || '',
            noOfEmployee: merchant?.noOfEmployee || '',
            workingSince: merchant?.workingSince || [],
            travelPrefer: merchant?.travelPrefer || [],
            serviceOffer: merchant?.serviceOffer || [],
            areaOfWork: merchant?.areaOfWork || [],
            deliveryDate: merchant?.deliveryDate || [],
        },
        enableReinitialize: true,
        validationSchema: photographerTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: {
                        ...values,
                        canditPrice: Math.floor(values.canditPrice * currency.country_value),
                        cinematicPrice: Math.floor(values.cinematicPrice * currency.country_value),
                        budgetPhotoPrice: Math.floor(values.budgetPhotoPrice * currency.country_value),
                        budgetVideoPrice: Math.floor(values.budgetVideoPrice * currency.country_value),
                        studioPhotoPrice: Math.floor(values.studioPhotoPrice * currency.country_value)
                    },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    const workingSinceOption = checkboxData.workSinceOption;
    const travelPreferenceOption = checkboxData.travelPreference
    const serviceOfferedOption = checkboxData.serviceOfferedPlanner
    const areaOfWorkingOption = checkboxData.areaOfWorking
    const deleryDateOption = checkboxData.deliveryDate
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header bg-primary text-white'>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Candid Photography Price</th>
                                                            <th style={{ width: '25%' }}>Cinematic Photography Price</th>
                                                            <th>Travel Preference</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.canditPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.cinematicPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>

                                                            <td>{
                                                                merchant.travelPrefer
                                                                    ?.map((item, index) => {
                                                                        return <span key={index}>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span >{item.value} </span>
                                                                        </span>
                                                                    })
                                                            }</td>

                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            {/* <th>Traditional Videography Price</th> */}
                                                            <th>Starting Photography Price </th>
                                                            <th>Starting Videography Price</th>
                                                            <th>Delivery Time</th>
                                                            <th>Area of Working </th>
                                                        </tr>
                                                        <tr>
                                                            {/* <td>&#8377; {merchant.videographyPrice}</td> */}

                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.budgetPhotoPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.budgetVideoPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>{
                                                                merchant.deliveryDate

                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span >{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.areaOfWork
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Studio Photography Price</th>
                                                            <th>Services Offered</th>
                                                            <th>Team Size</th>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.studioPhotoPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>{
                                                                merchant.serviceOffer
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <span key={index}>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span>{item.value} </span>
                                                                            </span>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td> {merchant.noOfEmployee}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )
                                }
                                <center>
                                    <button className='btn btn-primary mb-2' onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <label className="" htmlFor="inlineFormInputGroup">Candid Photography Price (Optional)</label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Candid Photography price'
                                                            className='form-control'
                                                            name="canditPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.canditPrice} />
                                                    </div>
                                                    {formik.touched.canditPrice && formik.errors.canditPrice ? (
                                                        <div className="text-danger">{formik.errors.canditPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="" htmlFor="inlineFormInputGroup">Cinematic Photography Price (Optional)</label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Candid Photography price'
                                                            className='form-control'
                                                            name="cinematicPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.cinematicPrice} />
                                                    </div>
                                                    {formik.touched.cinematicPrice && formik.errors.cinematicPrice ? (
                                                        <div className="text-danger">{formik.errors.cinematicPrice}</div>
                                                    ) : null}
                                                </div>
                                                {/* 
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Traditional Videography Price <span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Traditional Videography price'
                                                            className='form-control'
                                                            name="videographyPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.videographyPrice}
                                                        />
                                                        {formik.touched.videographyPrice && formik.errors.videographyPrice ? (
                                                            <div className="text-danger">{formik.errors.videographyPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div> */}
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travel Preference <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={travelPreferenceOption}
                                                            selected
                                                            value={formik.values.travelPrefer}
                                                            onChange={(travelPrefer) => formik.setFieldValue('travelPrefer', travelPrefer)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.travelPrefer && formik.errors.travelPrefer ? (
                                                            <div className="text-danger">{formik.errors.travelPrefer}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Services Offered <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={serviceOfferedOption}
                                                            selected
                                                            value={formik.values.serviceOffer}
                                                            onChange={(serviceOffer) => formik.setFieldValue('serviceOffer', serviceOffer)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.serviceOffer && formik.errors.serviceOffer ? (
                                                            <div className="text-danger">{formik.errors.serviceOffer}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="" htmlFor="inlineFormInputGroup">Starting Photography Price <span className='text-danger'>*</span></label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Candid Photography price'
                                                            className='form-control'
                                                            name="budgetPhotoPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.budgetPhotoPrice} />
                                                    </div>
                                                    {formik.touched.budgetPhotoPrice && formik.errors.budgetPhotoPrice ? (
                                                        <div className="text-danger">{formik.errors.budgetPhotoPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="" htmlFor="inlineFormInputGroup">Starting Videography Price <span className='text-danger'>*</span></label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Candid Photography price'
                                                            className='form-control'
                                                            name="budgetVideoPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.budgetVideoPrice} />
                                                    </div>
                                                    {formik.touched.budgetVideoPrice && formik.errors.budgetVideoPrice ? (
                                                        <div className="text-danger">{formik.errors.budgetVideoPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Delivery Time <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={deleryDateOption}
                                                            selected
                                                            value={formik.values.deliveryDate}
                                                            onChange={(deliveryDate) => formik.setFieldValue('deliveryDate', deliveryDate)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.deliveryDate && formik.errors.deliveryDate ? (
                                                            <div className="text-danger">{formik.errors.deliveryDate}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                {/* <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Small Function Starting Price (Photography & Videography) <span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Small function photography price (Photo & Video)'
                                                            className='form-control'
                                                            name="smallFunctionPhotoPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.smallFunctionPhotoPrice}
                                                        />
                                                        {formik.touched.smallFunctionPhotoPrice && formik.errors.smallFunctionPhotoPrice ? (
                                                            <div className="text-danger">{formik.errors.smallFunctionPhotoPrice}</div>
                                                        ) : null}
                                                    </div>
                                                </div> */}
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area of Working <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            value={formik.values.areaOfWork}
                                                            onChange={(selected) => formik.setFieldValue('areaOfWork', selected)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWork && formik.errors.areaOfWork ? (
                                                            <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="" htmlFor="inlineFormInputGroup">Studio Photography Price (Optional)</label>
                                                    <div className="input-group mb-2">
                                                        <div className="input-group-prepend">
                                                            <div className="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Candid Photography price'
                                                            className='form-control'
                                                            name="studioPhotoPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.studioPhotoPrice} />
                                                    </div>
                                                    {formik.touched.studioPhotoPrice && formik.errors.studioPhotoPrice ? (
                                                        <div className="text-danger">{formik.errors.studioPhotoPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Team Size <span className='text-danger'>*</span></label>
                                                        <input
                                                            type='number'
                                                            placeholder='Team Size'
                                                            className='form-control'
                                                            name="noOfEmployee"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.noOfEmployee}
                                                        />
                                                        {formik.touched.noOfEmployee && formik.errors.noOfEmployee ? (
                                                            <div className="text-danger">{formik.errors.noOfEmployee}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group text-center'>
                                                <button className='btn btn-primary' type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div></div></div>
    )
}
export default PhotographyTTK